import { Box, Button, Collapse, useDisclosure } from '@chakra-ui/react';
import { ChevronDownIcon } from '@udacity/chakra-uds-icons';

import { ContentContainer } from '~/components/container';
import { trackEvent } from '~/features/analytics/track-event';

import { PLANS_COMPARISON_COLUMNS, PLANS_COMPARISON_SECTIONS } from './plans-comparison-data';
import { PlansMatrix } from './plans-matrix';

const PANEL_ID = 'plans-comparison-panel';

export function PlansComparisonSection() {
  const { isOpen, onToggle } = useDisclosure({
    onOpen: () =>
      trackEvent({
        type: 'click',
        name: 'Plans Comparison Clicked',
        label: 'See Plan Comparison',
      }),
  });

  return (
    <Box as='section' bgColor='grey.50' pb={{ base: isOpen ? 16 : 12, lg: isOpen ? 24 : 16 }} pt={0}>
      <ContentContainer contentMaxWidth='content-max-width-md'>
        <Box textAlign='center'>
          <Button
            aria-controls={PANEL_ID}
            aria-expanded={isOpen}
            display='inline-flex'
            gap={2}
            size='icon-right'
            variant='ghost'
            rightIcon={
              <ChevronDownIcon
                height={5}
                transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
                transition='transform 0.2s ease'
                width={5}
              />
            }
            onClick={onToggle}
          >
            {isOpen ? 'Hide Plan Comparison' : 'See Plan Comparison'}
          </Button>
        </Box>
        <Collapse id={PANEL_ID} in={isOpen}>
          <Box
            bgColor='white'
            border='1px solid'
            borderColor='grey.200'
            borderRadius='12px'
            mt={{ base: 8, lg: 10 }}
            overflow='hidden'
          >
            <PlansMatrix columns={PLANS_COMPARISON_COLUMNS} sections={PLANS_COMPARISON_SECTIONS} />
          </Box>
        </Collapse>
      </ContentContainer>
    </Box>
  );
}
